import * as React from 'react';
import { Entry } from './entry';

export type EntrySelectedHandlerType = (key: string) => void;
export type EntryDictionary = { [id: string]: Entry };

interface EntryListProps {
  entries: EntryDictionary;
  onEntrySelected: EntrySelectedHandlerType;
  selectedEntryId: string;
}

export const EntryList: React.SFC<EntryListProps> = (props) => {
  return (
    <ul>
      {Object.keys(props.entries).map((k) => (
        <li
          className={props.selectedEntryId === k ? 'selectedEntry' : ''}
          key={k}
          onMouseDown={() => props.onEntrySelected(k)}
        >
          {/* Use a non-blocking space if short is not defined. Prevents a collapsed entry in the list */}
          {props.entries[k].short || '\u00A0'}
        </li>
      ))}
    </ul>
  );
};



// WEBPACK FOOTER //
// ./src/components/entryList.tsx